module.exports = __webpack_public_path__ + "static/img/Landing Page_Banner sin botón_Materiales@4x.fa237e54.png";